import { Icon, IconProps } from '@chakra-ui/react';

export const PlusIcon = (props: IconProps) => (
  <Icon width='15px' height='15px' viewBox='0 0 15 15' fill='#757575' {...props}>
    <rect x='6.25' width='2.3' height='14.8' fill='inherit' />
    <rect y='8.55005' width='2.3' height='14.8' transform='rotate(-90 0 8.55005)' fill='inherit' />
  </Icon>
);
